import { useMemo, useState } from 'react';

import { IDownloadModal } from './DownloadModal';

interface DateState {
  createdAtStart: string | null;
  createdAtEnd: string | null;
}

const useDownloadModal = ({ downloadReport }: IDownloadModal) => {
  const [dates, setDates] = useState<DateState>({ createdAtStart: null, createdAtEnd: null });

  const download = () => {
    if (dates.createdAtStart && dates.createdAtEnd) {
      downloadReport(dates.createdAtStart, dates.createdAtEnd);
    }
  };

  const isDisabled = useMemo(() => {
    if (!dates.createdAtStart || !dates.createdAtEnd) return true;
    return false;
  }, [dates]);

  return {
    dates,
    setDates,
    download,
    isDisabled,
  };
};

export default useDownloadModal;
